import api from 'services/api'

export const ANON_CART_KEY = '@CANNECT:ANONYMOUS_CART_SESSION'
const ANON_CART_RESOLVED_KEY = '@CANNECT:ANONYMOUS_CART_RESOLVED'

export const getSessionCartId = (): string | null => {
  return localStorage.getItem(ANON_CART_KEY)
}

export const setSessionCartId = (id: string): void => {
  localStorage.setItem(ANON_CART_KEY, id)
}

export const clearSessionCartId = (): void => {
  localStorage.removeItem(ANON_CART_KEY)
  localStorage.removeItem(ANON_CART_RESOLVED_KEY)
}

/**
 * Marca que a tentativa de conversão do carrinho anônimo `id` já teve seu
 * resultado conhecido (respondeu com ou sem order_id). Chamar assim que a
 * resposta do endpoint de autenticação/cadastro chegar, quando um
 * session_cart_id foi enviado.
 */
export const markSessionCartResolved = (id: string): void => {
  localStorage.setItem(ANON_CART_RESOLVED_KEY, id)
}

/**
 * Se não há id pendente, não há nada para resolver. Se há, só está resolvido
 * quando bate com o último id marcado por markSessionCartResolved.
 */
export const isSessionCartResolved = (id: string | null): boolean => {
  if (!id) return true
  return localStorage.getItem(ANON_CART_RESOLVED_KEY) === id
}

export const initSessionCartId = async (): Promise<string> => {
  const { data } = await api.post('/anonymous-cart', {})
  const sessionCartId = data?.data?.session_cart_id

  if (sessionCartId) {
    setSessionCartId(sessionCartId)
  }

  return sessionCartId
}
